import type { PendingUploadSendCopy } from './pending-upload-send-copy';

// Languages whose plurals don't map onto one/other use a count-neutral
// phrasing in both forms.
export const PENDING_UPLOAD_SEND_EASTERN_COPY = {
  ar: {
    uploadingFiles: {
      one: 'جارٍ رفع الملفات: {count}…',
      other: 'جارٍ رفع الملفات: {count}…',
    },
    needsAttention: {
      one: 'ملفات لم تُرفع: {count}.',
      other: 'ملفات لم تُرفع: {count}.',
    },
    heldUntilFixed: 'تُرسل رسالتك بعد رفع كل ملف أو إزالته.',
    waitingOtherDevice:
      'في انتظار اكتمال رفع ملفاتك. افتح IMAI على الجهاز الذي أرسلت منه للمتابعة.',
    starting: 'جارٍ البدء…',
    startFailed: 'تعذّر بدء هذه المهمة.',
    fileReady: 'تم الرفع',
    fileWaiting: 'في الانتظار',
    finishing: 'جارٍ الإنهاء…',
    fileFinishing: 'جارٍ الحفظ…',
    failureNetwork: 'انقطع الاتصال.',
    failureServer: 'لم يكتمل رفعه.',
    failureTooLarge: 'يتجاوز حد الرفع البالغ 2 غيغابايت.',
    failureUnavailable: 'يجب إرفاقه مرة أخرى.',
    failureUnknown: 'لم يتم رفعه.',
    retry: 'إعادة المحاولة',
    discard: 'تجاهل',
    remove: 'إزالة',
    retryFile: 'إعادة محاولة {name}',
    removeFile: 'إزالة {name}',
    progressLabel: 'تم رفع {percent}',
    backgroundUploading: {
      one: 'جارٍ رفع الملفات في الخلفية: {count}',
      other: 'جارٍ رفع الملفات في الخلفية: {count}',
    },
    backgroundNeedsAttention: {
      one: 'عمليات رفع تحتاج إلى انتباهك: {count}',
      other: 'عمليات رفع تحتاج إلى انتباهك: {count}',
    },
    backgroundFinishing: {
      one: 'جارٍ إنهاء {count} ملف…',
      other: 'جارٍ إنهاء {count} ملفات…',
    },
    actionFailed: 'لم يكتمل ذلك. حاول مرة أخرى.',
    openTask: 'فتح المهمة',
  },
  ko: {
    uploadingFiles: {
      one: '파일 {count}개 업로드 중…',
      other: '파일 {count}개 업로드 중…',
    },
    needsAttention: {
      one: '파일 {count}개를 업로드하지 못했어요.',
      other: '파일 {count}개를 업로드하지 못했어요.',
    },
    heldUntilFixed: '모든 파일이 업로드되거나 제거되면 메시지가 전송돼요.',
    waitingOtherDevice:
      '파일 업로드가 끝나기를 기다리는 중이에요. 계속하려면 메시지를 보낸 기기에서 IMAI를 여세요.',
    starting: '시작하는 중…',
    startFailed: '이 작업을 시작하지 못했어요.',
    fileReady: '업로드됨',
    fileWaiting: '대기 중',
    finishing: '마무리하는 중…',
    fileFinishing: '저장하는 중…',
    failureNetwork: '연결이 끊겼어요.',
    failureServer: '업로드를 끝내지 못했어요.',
    failureTooLarge: '2GB 업로드 한도를 넘었어요.',
    failureUnavailable: '다시 첨부해야 해요.',
    failureUnknown: '업로드하지 못했어요.',
    retry: '다시 시도',
    discard: '삭제',
    remove: '제거',
    retryFile: '{name} 다시 시도',
    removeFile: '{name} 제거',
    progressLabel: '{percent} 업로드됨',
    backgroundUploading: {
      one: '백그라운드에서 파일 {count}개 업로드 중',
      other: '백그라운드에서 파일 {count}개 업로드 중',
    },
    backgroundNeedsAttention: {
      one: '확인이 필요한 업로드 {count}개',
      other: '확인이 필요한 업로드 {count}개',
    },
    backgroundFinishing: {
      one: '업로드 {count}개 마무리하는 중…',
      other: '업로드 {count}개 마무리하는 중…',
    },
    actionFailed: '처리하지 못했어요. 다시 시도해 주세요.',
    openTask: '작업 열기',
  },
  ja: {
    uploadingFiles: {
      one: '{count}件のファイルをアップロード中…',
      other: '{count}件のファイルをアップロード中…',
    },
    needsAttention: {
      one: '{count}件のファイルをアップロードできませんでした。',
      other: '{count}件のファイルをアップロードできませんでした。',
    },
    heldUntilFixed:
      'すべてのファイルがアップロードされるか削除されると、メッセージが送信されます。',
    waitingOtherDevice:
      'ファイルのアップロード完了を待っています。続けるには、送信した端末で IMAI を開いてください。',
    starting: '開始しています…',
    startFailed: 'このタスクを開始できませんでした。',
    fileReady: 'アップロード済み',
    fileWaiting: '待機中',
    finishing: '仕上げています…',
    fileFinishing: '保存しています…',
    failureNetwork: '接続が切れました。',
    failureServer: 'アップロードが完了しませんでした。',
    failureTooLarge: '2 GB のアップロード上限を超えています。',
    failureUnavailable: 'もう一度添付してください。',
    failureUnknown: 'アップロードできませんでした。',
    retry: '再試行',
    discard: '破棄',
    remove: '削除',
    retryFile: '{name} を再試行',
    removeFile: '{name} を削除',
    progressLabel: '{percent} アップロード済み',
    backgroundUploading: {
      one: 'バックグラウンドで{count}件のファイルをアップロード中',
      other: 'バックグラウンドで{count}件のファイルをアップロード中',
    },
    backgroundNeedsAttention: {
      one: '対応が必要なアップロード: {count}件',
      other: '対応が必要なアップロード: {count}件',
    },
    backgroundFinishing: {
      one: '{count} 件のアップロードを仕上げています…',
      other: '{count} 件のアップロードを仕上げています…',
    },
    actionFailed: '処理できませんでした。もう一度お試しください。',
    openTask: 'タスクを開く',
  },
  hi: {
    uploadingFiles: {
      one: '{count} फ़ाइल अपलोड हो रही है…',
      other: '{count} फ़ाइलें अपलोड हो रही हैं…',
    },
    needsAttention: {
      one: '{count} फ़ाइल अपलोड नहीं हुई।',
      other: '{count} फ़ाइलें अपलोड नहीं हुईं।',
    },
    heldUntilFixed:
      'हर फ़ाइल अपलोड होने या हटाए जाने के बाद आपका संदेश भेजा जाएगा।',
    waitingOtherDevice:
      'आपकी फ़ाइलों के अपलोड पूरे होने का इंतज़ार है। जारी रखने के लिए उस डिवाइस पर IMAI खोलें जिससे आपने भेजा था।',
    starting: 'शुरू हो रहा है…',
    startFailed: 'यह टास्क शुरू नहीं हो सका।',
    fileReady: 'अपलोड हो गई',
    fileWaiting: 'इंतज़ार में',
    finishing: 'पूरा किया जा रहा है…',
    fileFinishing: 'सहेजा जा रहा है…',
    failureNetwork: 'कनेक्शन टूट गया।',
    failureServer: 'इसका अपलोड पूरा नहीं हुआ।',
    failureTooLarge: '2 GB अपलोड सीमा से बड़ी है।',
    failureUnavailable: 'इसे फिर से अटैच करना होगा।',
    failureUnknown: 'अपलोड नहीं हुई।',
    retry: 'फिर से कोशिश करें',
    discard: 'हटाएं',
    remove: 'हटाएँ',
    retryFile: '{name} फिर से आज़माएँ',
    removeFile: '{name} हटाएँ',
    progressLabel: '{percent} अपलोड हुआ',
    backgroundUploading: {
      one: 'बैकग्राउंड में {count} फ़ाइल अपलोड हो रही है',
      other: 'बैकग्राउंड में {count} फ़ाइलें अपलोड हो रही हैं',
    },
    backgroundNeedsAttention: {
      one: '{count} अपलोड पर ध्यान देना है',
      other: '{count} अपलोड पर ध्यान देना है',
    },
    backgroundFinishing: {
      one: '{count} अपलोड पूरा किया जा रहा है…',
      other: '{count} अपलोड पूरे किए जा रहे हैं…',
    },
    actionFailed: 'यह पूरा नहीं हुआ। फिर से कोशिश करें।',
    openTask: 'टास्क खोलें',
  },
  ru: {
    uploadingFiles: {
      one: 'Загрузка файлов: {count}…',
      other: 'Загрузка файлов: {count}…',
    },
    needsAttention: {
      one: 'Не загружено файлов: {count}.',
      other: 'Не загружено файлов: {count}.',
    },
    heldUntilFixed:
      'Сообщение отправится, когда все файлы будут загружены или удалены.',
    waitingOtherDevice:
      'Ждём, пока ваши файлы загрузятся. Откройте IMAI на устройстве, с которого вы отправили сообщение, чтобы продолжить.',
    starting: 'Запуск…',
    startFailed: 'Не удалось запустить эту задачу.',
    fileReady: 'Загружено',
    fileWaiting: 'Ожидание',
    finishing: 'Завершение…',
    fileFinishing: 'Сохранение…',
    failureNetwork: 'Соединение прервалось.',
    failureServer: 'Загрузка не завершилась.',
    failureTooLarge: 'Больше лимита загрузки 2 ГБ.',
    failureUnavailable: 'Нужно прикрепить заново.',
    failureUnknown: 'Не загружено.',
    retry: 'Повторить',
    discard: 'Отменить',
    remove: 'Удалить',
    retryFile: 'Повторить {name}',
    removeFile: 'Удалить {name}',
    progressLabel: 'Загружено {percent}',
    backgroundUploading: {
      one: 'Фоновая загрузка файлов: {count}',
      other: 'Фоновая загрузка файлов: {count}',
    },
    backgroundNeedsAttention: {
      one: 'Загрузки требуют внимания: {count}',
      other: 'Загрузки требуют внимания: {count}',
    },
    backgroundFinishing: {
      one: 'Завершается загрузка: {count}…',
      other: 'Завершаются загрузки: {count}…',
    },
    actionFailed: 'Не получилось. Попробуйте ещё раз.',
    openTask: 'Открыть задачу',
  },
  zh: {
    uploadingFiles: {
      one: '正在上传 {count} 个文件…',
      other: '正在上传 {count} 个文件…',
    },
    needsAttention: {
      one: '{count} 个文件未能上传。',
      other: '{count} 个文件未能上传。',
    },
    heldUntilFixed: '所有文件上传完成或移除后，你的消息就会发送。',
    waitingOtherDevice:
      '正在等待你的文件上传完成。请在发送消息的设备上打开 IMAI 以继续。',
    starting: '正在开始…',
    startFailed: '无法开始此任务。',
    fileReady: '已上传',
    fileWaiting: '等待中',
    finishing: '正在完成…',
    fileFinishing: '正在保存…',
    failureNetwork: '连接已中断。',
    failureServer: '未能完成上传。',
    failureTooLarge: '超过 2 GB 上传上限。',
    failureUnavailable: '需要重新附加。',
    failureUnknown: '未能上传。',
    retry: '重试',
    discard: '放弃',
    remove: '移除',
    retryFile: '重试 {name}',
    removeFile: '移除 {name}',
    progressLabel: '已上传 {percent}',
    backgroundUploading: {
      one: '正在后台上传 {count} 个文件',
      other: '正在后台上传 {count} 个文件',
    },
    backgroundNeedsAttention: {
      one: '{count} 个上传需要处理',
      other: '{count} 个上传需要处理',
    },
    backgroundFinishing: {
      one: '正在完成 {count} 个上传…',
      other: '正在完成 {count} 个上传…',
    },
    actionFailed: '操作未完成，请重试。',
    openTask: '打开任务',
  },
  'zh-TW': {
    uploadingFiles: {
      one: '正在上傳 {count} 個檔案…',
      other: '正在上傳 {count} 個檔案…',
    },
    needsAttention: {
      one: '{count} 個檔案未能上傳。',
      other: '{count} 個檔案未能上傳。',
    },
    heldUntilFixed: '所有檔案上傳完成或移除後，你的訊息就會送出。',
    waitingOtherDevice:
      '正在等待你的檔案上傳完成。請在傳送訊息的裝置上開啟 IMAI 以繼續。',
    starting: '正在開始…',
    startFailed: '無法開始這項任務。',
    fileReady: '已上傳',
    fileWaiting: '等待中',
    finishing: '正在完成…',
    fileFinishing: '正在儲存…',
    failureNetwork: '連線已中斷。',
    failureServer: '未能完成上傳。',
    failureTooLarge: '超過 2 GB 上傳上限。',
    failureUnavailable: '需要重新附加。',
    failureUnknown: '未能上傳。',
    retry: '重試',
    discard: '放棄',
    remove: '移除',
    retryFile: '重試 {name}',
    removeFile: '移除 {name}',
    progressLabel: '已上傳 {percent}',
    backgroundUploading: {
      one: '正在背景上傳 {count} 個檔案',
      other: '正在背景上傳 {count} 個檔案',
    },
    backgroundNeedsAttention: {
      one: '{count} 個上傳需要處理',
      other: '{count} 個上傳需要處理',
    },
    backgroundFinishing: {
      one: '正在完成 {count} 個上傳…',
      other: '正在完成 {count} 個上傳…',
    },
    actionFailed: '操作未完成，請再試一次。',
    openTask: '開啟任務',
  },
} satisfies Partial<Record<string, PendingUploadSendCopy>>;
